export default "<p>asset-usecases works!</p>\r\n";